import { render, staticRenderFns } from "./VideoReviewView.vue?vue&type=template&id=266815c8&"
import script from "./VideoReviewView.vue?vue&type=script&lang=js&"
export * from "./VideoReviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports